import { useSelector } from 'react-redux';
import styles from './styles.module.scss';
import { getUserRoleSelector } from 'store/selectors/user';

import { AGENT, TEAM_ADMIN, TEAM_BASIC, TEAM_OWNER } from 'settings/constants/roles';
import { useHistory, useLocation } from 'react-router-dom';
import {
  getAgentTeamDetailSelector,
  getAgentTeamIsActiveSelector,
  getAgentTeamRoleSelector,
} from 'store/selectors/agentTeamDetail';
import { routes } from 'settings/navigation/routes';
import classNames from 'classnames';
import useIsProjectRoute from 'hooks/use-is-project-route';
import { Icons } from 'pages/Workshop/Icons';

import { TransactionTeamFilter } from './TransactionTeamFilter';

import { ProjectTeamFilter } from './ProjectTeamFilter';
import { Filter } from 'pages/Workshop/Transactions/Filter';

export const TransactionActionButtons = (props) => {
  const userRole = useSelector(getUserRoleSelector);
  const { pathname } = useLocation();
  const history = useHistory();

  const isTeamAgentActive = useSelector(getAgentTeamIsActiveSelector);
  const agentRole = useSelector(getAgentTeamRoleSelector);

  const { data } = useSelector(getAgentTeamDetailSelector);
  const isProject = useIsProjectRoute();

  const renderNewButton = () => {
    const redirectTo = () => {
      if (isProject) history.push(routes.projectCreate);
      else history.push(routes.transactionCreate);
    };

    if (userRole === AGENT && (pathname === routes.projects || data?.CanCreateTransaction)) {
      return (
        <div className={classNames(styles.btn, styles.newBtn)} onClick={redirectTo}>
          <Icons className={styles.addIcon} variant={Icons.ADD} />
          <span className={styles.iconText}>New</span>
        </div>
      );
    }

    return '';
  };

  const renderTeamFilter = () => {
    if (isTeamAgentActive && [TEAM_OWNER, TEAM_ADMIN, TEAM_BASIC].includes(agentRole)) {
      if (pathname === routes.transactions) return <TransactionTeamFilter />;
      if (pathname === routes.projects) return <ProjectTeamFilter />;
    }
  };

  return (
    <div className={styles.actionButtonsPanel}>
      {renderNewButton()}
      {renderTeamFilter()}

      <div
        className={classNames(styles.btn, styles.iconButton, styles.searchButton)}
        onClick={props.onSearchClick}
      >
        <Icons className={styles.btnIcon} variant={Icons.SEARCH} color="#515151" />
      </div>

      <Filter isAggregatePage={true} />
    </div>
  );
};
